const groupPrefixStore = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)
const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.COUPONS)

export const apiCoupons = {
	/**
	 * @deprecated After changes we dont't use this endpoint anymore
	 * To collect coupon details with promotion details use fetchPromotion
	 */
	fetchCoupon: async (actionID: number) => {
		const { data } = await apiCommon<IDiscountCoupon>(`${groupPrefix}/${actionID}`, {
			method: 'GET',
		})
		return { data: Coupon(data) }
	},
	storeCoupon: async (
		promotionID: number,
		couponPayload: { code: string; usageLimit: number | null; perCustomerUsageLimit: number | null },
	) => {
		const { data } = await apiCommon<IDiscountCoupon>(`${groupPrefixStore}/${promotionID}/coupons`, {
			method: 'POST',
			body: {
				code: couponPayload.code,
				usage_limit: couponPayload.usageLimit,
				per_customer_usage_limit: couponPayload.perCustomerUsageLimit,
			},
		})
		return Coupon(data)
	},
	createDiscountCoupon: async (id: number, payload: IDiscountCouponCreatePayload) => {
		const { data } = await apiCommon<IDiscountCoupon>(`${groupPrefixStore}/${id}/coupons`, {
			method: 'POST',
			body: payload,
		})

		return Coupon(data)
	},
	updateCouponWithPayload: async (
		couponId: number,
		payload: IDiscountCouponUpdatePayload,
	): Promise<IDiscountCouponModel> => {
		const { data } = await apiCommon<IDiscountCoupon>(`${groupPrefix}/${couponId}`, {
			method: 'PUT',
			body: payload,
		})
		return Coupon(data)
	},
	updateCoupon: async (actionID: number, form: any) => {
		const { data } = await apiCommon<IDiscountCoupon>(`${groupPrefix}/${actionID}`, {
			method: 'PUT',
			body: { ...couponToJSON(form) },
		})
		return Coupon(data)
	},
	deleteCoupon: async (actionID: number): Promise<void> => {
		await apiCommon<IDiscountCoupon>(`${groupPrefix}/${actionID}`, { method: 'DELETE' })
	},
}
